/* eslint-disable no-undef */
const Cls = (Sofatutor.Classes.VideoRatings = class VideoRatings {
  static initClass() {
    this.starsActiveClass = 'is-clicked';
    this.ratingChanged = false;
    this.starsFinalActiveCount = null;
  }

  constructor(wrapper) {
    const $starRating = $('.rating-stars:visible', wrapper);
    const $ratingContainer = $starRating.parent();
    const $stars = $starRating.find('.rating-stars__star');
    const $starsActive = $starRating.find('.is-active, .is-clicked');
    const $halfStar = $starRating.find('.rating-stars__icon--half-star');
    let starsActiveCount = $starsActive.length;
    const $googleRating = $('.google-rating', wrapper);
    const $unratedHeadline = $('.js-unrated-headline');
    const $ratedHeadline = $('.js-rated-headline');

    const starIsHalfStar = $star =>
      $halfStar.length && $star.is('.rating-stars__icon--half-star');

    if ($starsActive[0] != null) {
      if ($starsActive[0].classList.contains('is-active')) {
        VideoRatings.starsActiveClass = 'is-active';
      }
    }

    $stars.on('click', function() {
      const clickTarget = this;

      $('.videos-rating__info').addClass('is-hidden');
      $('.videos-rating__feedback').removeClass('is-hidden');
      $unratedHeadline.addClass('is-hidden');
      $ratedHeadline.removeClass('is-hidden');

      if (Sofatutor.logged_in) {
        VideoRatings.ratingChanged = true;
        VideoRatings.starsActiveClass = 'is-clicked';
        const indexOfStar = $stars.toArray().indexOf(clickTarget);

        $starRating.addClass('is-rated');

        $.each($('.rating-stars'), (key, rating) =>
          (() => {
            const result = [];
            const iterable = $(rating).find('.rating-stars__star');
            for (let index = 0; index < iterable.length; index++) {
              var star = iterable[index];
              $(star)
                .find('.rating-stars__icon')
                .removeClass('is-active');
              $(star)
                .find('.rating-stars__icon')
                .removeClass('is-clicked');

              if (index <= indexOfStar) {
                result.push(
                  $(star)
                    .find('.rating-stars__icon')
                    .addClass('is-clicked')
                );
              } else {
                result.push(undefined);
              }
            }
            return result;
          })()
        );

        VideoRatings.starsFinalActiveCount = $starRating.find(
          '.is-clicked:visible'
        ).length;
        const googleReviewCookie = $.cookie('_sofatutor_google_review');

        if (VideoRatings.starsFinalActiveCount === 5) {
          if (Sofatutor.browser.isMobileApp) {
            const appEvent = Sofatutor.MobileApp.createEvent(
              'triggerAppRating'
            );
            Sofatutor.MobileApp.sendEvent(appEvent);
          } else if (!googleReviewCookie) {
            $googleRating.removeClass('is-hidden');
          }
          const expirationTime = new Date();
          const lifeTime = 31 * 24 * 3600 * 1000; // 31 days in milliseconds
          expirationTime.setTime(expirationTime.getTime() + lifeTime);

          if (Sofatutor.consentGivenForCategory('functionality')) {
            $.cookie('_sofatutor_google_review', true, {
              expires: expirationTime
            });
          }
        }

        return $.post($(clickTarget).data('ratingUrl'));
      } else {
        return setTimeout(function() {
          $('.videos-rating__info', $ratingContainer).removeClass('is-hidden');
          return $('.videos-rating__feedback', $ratingContainer).addClass(
            'is-hidden'
          );
        }, 10000);
      }
    });

    $stars.on('mouseenter', function() {
      const indexOfStar = $stars.toArray().indexOf(this);

      return (() => {
        const result = [];
        for (let index = 0; index < $stars.length; index++) {
          var star = $stars[index];
          var $starIcon = $(star).find('.rating-stars__icon');

          if (index <= indexOfStar) {
            result.push($starIcon.addClass('is-hovered'));
          } else {
            result.push(
              $starIcon.removeClass('is-hovered is-clicked is-active')
            );
          }
        }
        return result;
      })();
    });

    $stars.on('mouseleave', function() {
      if (VideoRatings.ratingChanged) {
        starsActiveCount = VideoRatings.starsFinalActiveCount;
      }

      return (() => {
        const result = [];
        for (let index = 0; index < $stars.length; index++) {
          var star = $stars[index];
          var $starIcon = $(star).find('.rating-stars__icon');
          $starIcon.removeClass('is-hovered');

          if (index < starsActiveCount && !starIsHalfStar($starIcon)) {
            result.push($starIcon.addClass(VideoRatings.starsActiveClass));
          } else {
            result.push(undefined);
          }
        }
        return result;
      })();
    });

    $googleRating.on('click', '.js-google-rating-link', function() {
      return $googleRating.addClass('is-hidden');
    });

    $googleRating.on('click', '.info-close', function() {
      return $googleRating.addClass('is-hidden');
    });
  }
});
Cls.initClass();

$(function() {
  if (!$('.videos-content-container').length) {
    return;
  }
  return new Sofatutor.Classes.VideoRatings(
    '.videos-content-container .videos-rating-container'
  );
});
